import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChallengesService } from '../../features/challenges/challenges.service';
import { TagsLanguageService } from '../../features/tags-language/tagsLanguage.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { MatDialog } from '@angular/material/dialog';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';

@Component({
  selector: 'app-challenges',
  imports: [
    CommonModule,
    NoDataComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    PermissionDirective,
    ContentLoaderComponent,
  ],
  templateUrl: './challenges.component.html',
  styleUrl: './challenges.component.scss',
})
export class ChallengesComponent {
  readonly dialog = inject(MatDialog);
  public challengeList: any[] = [];
  public languages: any[] = [];
  public langCode: String = '';
  private searchSubject = new Subject<string>();
  noData = false;
  loading = false;
  searchTerm: string = '';

  constructor(
    private router: Router,
    private tagsService: TagsLanguageService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private challengeService: ChallengesService
  ) { }

  ngOnInit() {
    this.getAllChallenges(this.langCode);
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getAllChallenges(this.langCode, searchTerm);
      });
  }

  getLanguages(): void {
    this.tagsService.getLangauges().subscribe({
      next: (res) => {
        if (res?.data) {
          this.languages = res?.data;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/placeHolderImage.jpg';
  }

  getAllChallenges(lang: any, search = ''): void {
    this.loading = true;
    this.noData = false;

    this.challengeService.getAllChallenges(lang, search).subscribe({
      next: (res) => {
        this.challengeList = res?.data || [];
        this.noData = this.challengeList.length === 0;
        this.loading = false;
      },
      error: () => {
        this.challengeList = [];
        this.noData = true;
        this.loading = false;
      },
    });
  }


  onAddChallenge() {
    this.router.navigate(['challenges/new']);
  }

  deleteChallenege(id: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.challengeService.deleteChallenge(id).subscribe({
          next: (res) => {
            this.toastr.success(res?.message);
            this.getAllChallenges(this.langCode);
          },
          error: (err) => {
            console.log(err);
          },
        });
      }
    });
  }

  onEditChallenge(id: any) {
    this.router.navigate([`challenges/edit/${id}`]);
  }
}
